export function getGoAccountsApiURL(): string {
	if (process.env.REACT_APP_GOACCOUNTS_URL) {
		return process.env.REACT_APP_GOACCOUNTS_URL;
	}
	return "http://app.goaccounts.local";
}

export function getApiURL(): string {
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL;
	}
	return "http://app.gostock2.local";
}

export function getTokenClientId(): string {
	if (process.env.REACT_APP_CLIENT_ID) {
		return process.env.REACT_APP_CLIENT_ID;
	}

	return "client_id_ajax_dev";
}

export function getTokenClientSecret(): string {
	if (process.env.REACT_APP_CLIENT_SECRET) {
		return process.env.REACT_APP_CLIENT_SECRET;
	}

	return "client_id_ajax_dev";
}

export function getSentryDSN() {
	if (process.env.REACT_APP_SENTRY_DSN) {
		return process.env.REACT_APP_SENTRY_DSN;
	}

	return "";
}

export function getGoogleAnalyticsId(): string | undefined {
	if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
		return process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
	}
	return undefined;
}
